<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { screenSizeMixin } from '@listen360/alexandria'
import { mapActions } from 'vuex'

export default {
  name: 'App',
  mixins: [screenSizeMixin],
  methods: {
    ...mapActions({
      updateBreakpoint: 'screen/updateBreakpoint'
    }),
    updateScreenSize({ width, height }) {
      this.updateBreakpoint({ width, height })
    }
  }
}
</script>
